import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Header.css';

function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const isHomePage = location.pathname === '/';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  const handleNavClick = (e, target) => {
    if (isHomePage && target.startsWith('#')) {
      e.preventDefault();
      const element = document.querySelector(target);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
      closeMobileMenu();
    } else {
      closeMobileMenu();
    }
  };

  const handleContactClick = () => {
    if (isHomePage) {
      const element = document.querySelector('#contact');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      navigate('/contact');
    }
    closeMobileMenu();
  };

  return (
    <header className={`header ${scrolled ? 'scrolled' : ''}`}>
      <div className="header-container">
        <Link to="/" className="logo" onClick={closeMobileMenu}>
          <img src="/logo.png" alt="Viviworks.IA" className="logo-icon" />
          <span className="logo-text">Viviworks<span className="logo-ai">.ai</span></span>
        </Link>
        
        <button 
          className={`hamburger ${mobileMenuOpen ? 'active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <nav className={`nav ${mobileMenuOpen ? 'mobile-open' : ''}`}>
          <Link to="/" className="nav-link" onClick={closeMobileMenu}>Accueil</Link>
          <Link to="/services" className="nav-link" onClick={closeMobileMenu}>Services</Link>
          <Link to="/realisations" className="nav-link" onClick={closeMobileMenu}>Projets</Link>
          
          {isHomePage ? (
            <a href="#blog" className="nav-link" onClick={(e) => handleNavClick(e, '#blog')}>Blog</a>
          ) : (
            <Link to="/blog" className="nav-link" onClick={closeMobileMenu}>Blog</Link>
          )}
          
          <button className="btn-contact mobile-contact" onClick={handleContactClick}>Contactez-nous</button>
        </nav>

        <button className="btn-contact desktop-contact" onClick={handleContactClick}>Contactez-nous</button>
      </div>
    </header>
  );
}

export default Header;

